import { Skeleton } from 'antd'
import React from 'react'
import './ImageLoadingSkeleton.scss'

const ImageLoadingSkeleton = () => {
  return (
    <Skeleton
      active
      avatar={{ size: 'large', shape: 'default' }}
      title={false}
      paragraph={{ width: '100%', row: 1 }}
      className='image-loading-skeleton'
    />
  )
}

export default ImageLoadingSkeleton
